import { getQueryMethod, resources, entities, methods } from '../utils';
const { meloAPI } = resources;
const { users } = entities;
const { PATCH } = methods;

const query = getQueryMethod(meloAPI, users);

const endpoints = {
  getUser: async userId => {
    return await query(userId);
  },
  updateUser: async (userId, fieldsToUpdate) => {
    return await query(userId, PATCH, fieldsToUpdate);
  }
};

export default endpoints;
